import * as React from 'react'
import { graphql, useStaticQuery } from "gatsby"
import { getImage } from 'gatsby-plugin-image'
import { useTranslation } from "gatsby-plugin-react-i18next"

import { Text } from "../Text/Text"
import { ThreeColumnItem } from "./three-column-item/ThreeColumnItem"

export const ThreeColumn = () => {
  const imageQuery = useStaticQuery(graphql`
  query ThreeColumn {
    colImageOne: file(
      relativePath: { eq: "three-column/icn-money.png" }
    ) {
      childImageSharp {
        gatsbyImageData(layout: FIXED, width: 80)
      }
      publicURL
    },
    colImageTwo: file(
      relativePath: { eq: "three-column/icn-phone.png" }
    ) {
      childImageSharp {
        gatsbyImageData(layout: FIXED, width: 80)
      }
      publicURL
    },
    colImageThree: file(
      relativePath: { eq: "three-column/icn-heart.png" }
    ) {
      childImageSharp {
        gatsbyImageData(layout: FIXED, width: 80)
      }
      publicURL
    }
  }
`)

  const imageOne = getImage(imageQuery.colImageOne)
  const imageTwo = getImage(imageQuery.colImageTwo)
  const imageThree = getImage(imageQuery.colImageThree)

  const { t } = useTranslation("shared", {
    keyPrefix: "three_column",
  });

  return (
    <div className="max-w-content-width mx-auto py-8 md:py-16 px-5">
      <Text variant="medium-header">{t("title")}</Text>
      <div className="grid md:gap-6 md:grid-cols-3 md:mt-16">
        <ThreeColumnItem
          eyebrow={t("item_1.eyebrow")}
          imageAlt={t("item_1.image_alt")}
          imageData={imageOne}
          intro={t("item_1.intro")}
          title={t("item_1.title")}
        />
        <ThreeColumnItem
          eyebrow={t("item_2.eyebrow")}
          imageAlt={t("item_2.image_alt")}
          imageData={imageTwo}
          intro={t("item_2.intro")}
          title={t("item_2.title")}
        />
        <ThreeColumnItem
         eyebrow={t("item_3.eyebrow")}
         imageAlt={t("item_3.image_alt")}
         imageData={imageThree}
         intro={t("item_3.intro")}
         title={t("item_3.title")}
        />
      </div>
    </div>
  )
}
